__webpack_require__.nmd = function(module) {
	module.paths = [];
	if (!module.children) module.children = [];
	return module;
};